export default __webpack_public_path__ + "static/media/clock.f6c06365.svg";